import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-gray-lp-800 text-10px italic mb-6" }
const _hoisted_2 = { class: "flex flex-col gap-6" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "my-2" }
const _hoisted_5 = { class: "text-gray-lp-800 text-10px italic mt-0.5" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "my-2" }
const _hoisted_8 = { class: "text-gray-lp-800 text-10px italic mt-0.5" }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_DownloadAttachmentPreview = _resolveComponent("DownloadAttachmentPreview")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Title, {
      label: _ctx.$t('clientManagement.managementDetail.tabs.cooperationAgreement')
    }, null, 8, ["label"]),
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.newestUpdated.updatedAt) + " " + _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.by")) + " " + _toDisplayString(_ctx.newestUpdated.updatedByName), 1),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_DataWrapper, {
          fontSize: 14,
          class: "w-6/12",
          label: _ctx.$t('clientManagement.managementDetail.startedFrom'),
          value: _ctx.detailData.clientBilling.formattedStartDate
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          fontSize: 14,
          class: "w-6/12",
          label: _ctx.$t('clientManagement.managementDetail.until'),
          value: _ctx.detailData.clientBilling.formattedEndDate
        }, null, 8, ["label", "value"])
      ]),
      _createVNode(_component_DataWrapper, {
        fontSize: 14,
        class: "w-full",
        label: _ctx.$t('clientManagement.managementDetail.frpDocument')
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_4, [
            (_ctx.detailData.clientBilling.attachmentUrl)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_DownloadAttachmentPreview, {
                    dash: false,
                    name: _ctx.detailData.clientBilling.fileNameAttachment,
                    url: _ctx.detailData.clientBilling.attachmentUrl,
                    maxLength: 10000,
                    showPreview: _ctx.canPreviewAttachment,
                    activityHeader: "access-attachment-client-parent"
                  }, null, 8, ["name", "url", "showPreview"]),
                  _createVNode("div", _hoisted_5, _toDisplayString(_ctx.contractAttachmentUpdatedAt) + " " + _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.by")) + " " + _toDisplayString(_ctx.contractAttachmentUpdatedBy), 1)
                ], 64))
              : (_openBlock(), _createBlock("p", _hoisted_6, "-"))
          ])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_DataWrapper, {
        fontSize: 14,
        class: "w-full",
        label: _ctx.$t('clientManagement.managementDetail.pksDocument')
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_7, [
            (_ctx.hasPksAttachment)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_DownloadAttachmentPreview, {
                    attachmentClassName: "break-all",
                    dash: false,
                    name: _ctx.detailData.clientBilling.fileNamePKSAttachment,
                    url: _ctx.detailData.clientBilling.pksAttachment,
                    maxLength: 10000,
                    showPreview: _ctx.canPreviewAttachmentPKS,
                    activityHeader: "access-attachment-client-parent"
                  }, null, 8, ["name", "url", "showPreview"]),
                  _createVNode("div", _hoisted_8, _toDisplayString(_ctx.pksAttachmentUpdatedAt) + " " + _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.by")) + " " + _toDisplayString(_ctx.pksAttachmentUpdatedBy), 1)
                ], 64))
              : (_openBlock(), _createBlock("p", _hoisted_9, "-"))
          ])
        ]),
        _: 1
      }, 8, ["label"])
    ])
  ], 64))
}